module.exports = __webpack_public_path__ + "static/img/3_1_2.cf40a915.jpg";